import errorIconSvg from "static/images/alert-circle.svg";

interface Props {
  message: string;
}

export default function ControlErrorDisplay(props: Props) {
  return (
    <div className="absolute mt-0.5">
      <div className="flex">
        <img src={errorIconSvg} className="inline" alt="Error" />
        <span className="text-sm text-promRed1 ml-1 inline">
          {props.message}
        </span>
      </div>
    </div>
  );
}
